import { Component, OnInit, Input, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DadosBuscaContratoModel } from '../model/dados-busca-contrato.model';
import { RegistroService } from './../services/registro.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { CertificadoService } from '../services/certificado.service';
import { LoadService } from '../services/load.service';
import DadosCertificadoModel from '../model/dados-certificado.model';
import DadosRegistroModel from '../model/dados-registro.model';
import { ImpressaoService } from '../services/impressao.service';
import { RequestImpressaoModel } from '../model/request-impressao.model';
import { DOCUMENT } from '@angular/common';
import { CnsController } from '../cns-controller';
import { MatDialog } from '@angular/material';
import { MessageService } from '../services/message.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'app-registro-sucesso',
  templateUrl: './registro-sucesso.component.html',
  styleUrls: ['./registro-sucesso.component.css']
})
export class RegistroSucessoComponent extends CnsController implements OnInit {

  public numeroContrato: number;
  public contrato: any;
  mensagemSucesso: string;
  restrito: number; //1-restrito 2-amplo.
  mensagem: string;
  funcionalidade:string;
  perfil: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private matDialog: MatDialog,
    private messageService: MessageService,
    private registroService: RegistroService,
    private certificadoService: CertificadoService,
    private impressaoService: ImpressaoService,
    @Inject(DOCUMENT) private document: any
  ) { 
    super(router, matDialog, messageService);
  }

  ngOnInit() {
    this.registroService.OnInit();
    this.obterParamFuncionalidade();
    this.obterParamNumContrato();
    this.obterParamRestrito();
    this.obterParamPerfil();
    this.preencheMensagemTela();
    
    // this.loadService.isLoading.unsubscribe();
  }

  get dadosCertificado(): DadosCertificadoModel {
    const dados = sessionStorage['dadosCertificado'];
    // console.log('dadosCertificado: ' + dados);
    return undefined === dados || dados === "undefined" ? undefined : JSON.parse(dados);
  }

  get dadosRegistro(): DadosRegistroModel {
    const dados = sessionStorage['dadosRegistro'];
    //  console.log('dadosRegistro: ' + dados);
     return undefined === dados || dados === "undefined" ? undefined : JSON.parse(dados);    
  }

  private obterParamNumContrato(){
      this.numeroContrato = +this.route.snapshot.paramMap.get('contrato');
  }

  private obterParamRestrito(){
    this.restrito = +this.route.snapshot.paramMap.get('restrito');
    // console.log("restrito ", this.restrito);
  }

  private obterParamFuncionalidade(){
    this.funcionalidade = this.route.snapshot.paramMap.get('funcionalidade');
  }

  private obterParamPerfil(){
    this.perfil = +this.route.snapshot.paramMap.get('perfil');
  }

  private async obterDadosResponsavel() {
    return this.certificadoService.obterDadosCertificadoServlet();
  }

  get currentUrl(): string {
    return this.document.location.href;
  }

  private async prepararParams(): Promise<any> {
    return new Promise(res => {
      const params: RequestImpressaoModel = new RequestImpressaoModel();
      params.layout = 'contrato';
      params.numeroDocumento = this.numeroContrato+'';
      params.grauSigilo = 1;
      params.url = this.currentUrl;
      res(params);
    });
  }

  async downloadContrato() {
    const params = await this.prepararParams();
    const retorno = await this.impressaoService.downaloadPdfContrato(params);
    const strArquivo64 = retorno['arquivo'];
    const nomeArq: string = retorno['nomeArquivo'];
    const url = this.gerarURLDownload(strArquivo64, null, nomeArq, null);
    this.promptDownload(url, nomeArq);
    
  }

  private preencheMensagemTela(){
    this.mensagem = this.restrito === 1 ? this.mensagemPreRegistro() : this.mensagemRegistroSucesso();
     
  }

  private mensagemPreRegistro(){
    let texto: string
    
      if (this.funcionalidade==='registrar'){   
        texto = '<b>Pré-registro efetuado com sucesso!</b> <br>';
      }else{
        texto = '<b>Pré-Registro renovado com sucesso!</b> <br>';
      }
        
        if(this.perfil === 22){
          texto = texto + 'Para autorização, encaminhar a Carteira de Identidade e Documento Funcional do Procurador , digitalizados, no endereço <a href="https://www.gerirdemandas.conectividade.caixa.gov.br/" id="meulink" target="_blank"> https://www.gerirdemandas.conectividade.caixa.gov.br</a>, selecionando a opção “Entrada de Dados”, “Nova Demanda”, serviço “Autorização de Perfil Restrito”, produto “Perfil Restrito MPT”.';
        }else if (this.perfil === 12){
          texto = texto + 'Para autorização, encaminhar a Carteira de Identidade Profissional do Magistrado, digitalizada, no endereço <a href="https://www.gerirdemandas.conectividade.caixa.gov.br/" target="_blank"> https://www.gerirdemandas.conectividade.caixa.gov.br</a>, selecionando a opção “Entrada de Dados”, “Nova Demanda”, serviço “Autorização de Perfil Restrito”, produto “Perfil Restrito Magistrado”.';
        }else{
           texto = texto + this.funcionalidade==='registrar' ? 'Para validação apresentar documentação comprobatória em umas das agências da Caixa Econômica Federal.' :
           'Pré-Registro renovado com sucesso. Para autorização apresentar documentação comprobatória em uma agência Caixa.';
        }
        return texto;

  }

  private mensagemRegistroSucesso(){
    if (this.funcionalidade==='registrar'){
      return "Registro realizado com sucesso.";  
    }else{    
      return "Registro Renovado com sucesso.";  
    }
  }


  // async downloadContrato() {
  //   let contrato: DadosBuscaContratoModel = new DadosBuscaContratoModel();
  //   contrato.nuContrato = this.numeroContrato+'';
  //   await this.registroService.buscaContratoRegistro(contrato).then(data => {
  //     this.contrato = data['data']['contrato'];
  //     this.gerarPDFContrato(contrato.nuContrato, this.contrato);
  //   });
  // }

  // private gerarPDFContrato(nu_contrato: any, contentPDF: String) {

  //   const nomeArquivo = 'Contrato_'.concat(nu_contrato).concat('.pdf');
  //   this.obterDadosResponsavel().then(function (result) {
  //     const codigoSerial = result['codigoSerial'];
  //     const docDefinition = {
  //       info: {
  //         title: nomeArquivo,
  //         author: 'CEF',
  //         subject: 'Contrato de Serviços - ' + nu_contrato,
  //         // keywords: 'keywords for document',
  //       },
  //       header:function(){
  //         return {
  //           margin: 8,
  //           columns: [{
  //             text: '#EXTERNO.CONFIDENCIAL',
  //             alignment: 'right',
  //             fontSize:9
  //           }]
  //         }
  //       },
  //       content: contentPDF.toString() + '\n\n\nCodigo Serial: ' + codigoSerial,
  //     }
  //     pdfMake.createPdf(docDefinition).download(nomeArquivo);
  //   });
  // }



}
